module.exports = __webpack_public_path__ + "static/media/providerOrder.1fb04bc6.svg";